import { Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import AddIndiaRecycling from "./AddIndiaRecycling";
import HelperService from "../../utility/HelperService";

const IndiaRecycling = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [data, setData] = useState<any>(null);
  const [isLoading, setLoading] = useState(false);
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    WebService.getAPI({
      action: `council/getContent?type=INDIA_RECYCLE`,
    })
      .then((res: any) => {
        const perm = res?.data?.permissions || {};
        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err: any) => {
        setLoading(false);
        // toast.error(err.response?.data?.message || "An error occurred");
      });
  };

  return (
    <>
      <AddIndiaRecycling
        show={showAddModal}
        handleClose={() => {
          setShowAddModal(false);
          getData();
        }}
        data={data}
      />
      <div className="events-main">
        <Card className="event-card p-4">
          {isLoading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: 100 }}
            >
              <span
                className="spinner-border"
                role="status"
                aria-hidden="true"
              ></span>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-between align-items-center">
                <div className="page-title">
                  India Recycling and Re-use Council
                </div>
                {pagePermission.canAdd && (
                  <CustomButton
                    isLoading={false}
                    label={data ? "Edit" : "Add"}
                    onClick={() => {
                      setShowAddModal(true);
                    }}
                    style={{ width: 100 }}
                  />)}
              </div>
              {data === null ? (
                <div>No data found</div>
              ) : (
                <>
                  {data?.logo && (
                    <div className="mb-2 mt-2">
                      <img
                        src={data.logo}
                        alt="Event"
                        style={{ objectFit: "contain", width: 300 }}
                        className="border rounded-3 p-2"
                      />
                    </div>
                  )}
                  <div className="mb-3">
                  {data.title && <strong>Title</strong>}
                  {data?.title && <div>{data.title}</div>}
                  </div>
                  {data.subtitle && <strong>SubTitle</strong>}
                  {data?.subtitle && <div>{data.subtitle}</div>}
                  {data?.images && data.images.length > 0 && (
                    <strong>Images</strong>
                  )}
                  {data?.images &&
                    data.images.map((img: string, index: number) => (
                      <div key={index} className="mb-2 mt-2">
                        <img
                          src={img}
                          alt={`Event Image ${index + 1}`}
                          style={{
                            objectFit: "contain",
                            width: "20%",
                            height: "auto",
                          }}
                          className="border rounded-3 p-2"
                        />
                      </div>
                    ))}
                  {data?.description && <strong>Description</strong>}
                  {data?.description && (
                    <div className="ql-snow">
                      <div
                        className="mt-2 px-0 ql-editor"
                        dangerouslySetInnerHTML={{ __html: HelperService.getPreviewableHTML(data.description) }}
                      />
                    </div>
                  )}
                  {data?.mainPageContent && <strong>Main Page Content</strong>}
                  {data?.mainPageContent && (
                    <div
                      dangerouslySetInnerHTML={{ __html: HelperService.getPreviewableHTML(data.mainPageContent) }}
                    />
                  )}
                  {data?.members && data?.members?.length > 0 && (
                    <strong>Members</strong>
                  )}
                  {data?.members?.length > 0 && (
                    <div className="d-flex flex-wrap">
                      {data.members.map((member: any, index: number) => (
                        <div key={member._id || index} className="mb-2 mt-2">
                          {member.logo && (
                            <img
                              src={member.logo}
                              alt={member.name || `Member ${index + 1}`}
                              style={{ objectFit: "contain", width: 200 }}
                              className="border rounded-3 p-2 ms-2"
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  )}

                  {data?.key_initiavtives &&
                    data.key_initiavtives.length > 0 && (
                      <>
                        <h5 className="mt-4 mb-3">Key Initiatives</h5>

                        <div className="d-flex flex-wrap gap-3">
                          {data.key_initiavtives.map(
                            (data: any, index: number) => (
                              <div
                                key={data._id || index}
                                className="border rounded-3 p-3 d-flex flex-column align-items-center"
                                style={{ width: 220 }}
                              >
                                {/* LOGO */}
                                {data.logo && (
                                  <img
                                    src={data.logo}
                                    alt={data.title || `Key Area ${index + 1}`}
                                    style={{
                                      width: 160,
                                      height: 120,
                                      objectFit: "contain",
                                    }}
                                    className="mb-2"
                                  />
                                )}

                                {/* TITLE */}
                                {data.title && (
                                  <div className="text-center fw-semibold">
                                    {data.title}
                                  </div>
                                )}
                              </div>
                            )
                          )}
                        </div>
                      </>
                    )}
                </>
              )}
            </>
          )}
        </Card>
      </div>
    </>
  );
};

export default IndiaRecycling;
